import { IndustriesType } from "../../Models/IndustriesType";
import { useParams } from "react-router-dom";
import AddUpdateForm from "../../Components/AddUpdateForm";
import { Card } from "react-bootstrap";
import ActivityLogs from "../../Components/ActivityLogs";

interface AddUpdateProps {
  title?: any;
}

interface Field {
  id: string;
  title: string;
  type: string;
  col: number;
  description?: string;
  placeholder?: string;
  validate?: {
    rule: (value: any) => boolean;
    message: string;
  }[];
  required: boolean;
}

const AddUpdate: React.FC<AddUpdateProps> = () => {
  const { id } = useParams();
  let title = "Industries Type";

  const formFields: Field[] = [
    {
      id: "title",
      title: "Title",
      type: "string",
      placeholder: "Enter Title",
      col: 6,
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Title is required",
        },
      ],
      required: true,
    },
    {
      id: "description",
      title: "Description",
      type: "string",
      placeholder: "Enter Description",
      col: 6,
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Description is required",
        },
      ],
      required: true,
    },
  ];

  return (
    <>
      <div>
        <AddUpdateForm
          formFields={formFields}
          model={IndustriesType}
          title={title}
        />
      </div>
      {id && (
        <Card className="border-0 activity-card">
          <Card.Header className="mb-4">Activity Logs</Card.Header>
          <ActivityLogs auditable_type={"INDUSTRIES_TYPE"} id={id} />
        </Card>
      )}
    </>
  );
};

export default AddUpdate;
